var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"indexPage"},[_c('h1',[_vm._v("当前账户，此模块没有菜单")])])
}]

export { render, staticRenderFns }